import React from "react";
import { useNavigate } from "react-router-dom";

export default function DealsCard({ item }) {
  const navigate = useNavigate();

  const handleBookNow = () => {
    const slug = item?.heading
      ?.toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");

    navigate(`/offer-details?${slug}`, {
      state: { data: item },
    });
  };

  return (
    <article className="group w-full overflow-hidden rounded-2xl bg-white transition-all duration-300 hover:-translate-y-1">
      {/* ================= IMAGE ================= */}
      <div className="relative aspect-[4/2] w-full overflow-hidden">
        {/* Desktop Image */}
        <img
          src={`https://api.maharajaflights.com/storage/${item?.image}`}
          alt={item?.heading || "Flight deal"}
          className="hidden h-full w-full object-contain transition-transform duration-500 group-hover:scale-105 sm:block"
          loading="lazy"
        />

        {/* Mobile / Instagram Image */}
        <img
          src={`https://api.maharajaflights.com/storage/${item?.inner_image}`}
          alt={item?.heading || "Flight deal"}
          className="block h-full w-full object-contain transition-transform duration-500 group-hover:scale-105 sm:hidden"
          loading="lazy"
        />

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />

        {/* Deal Badge */}
        {item?.badge && (
          <span className="absolute left-4 top-4 rounded-full bg-red-500 px-3 py-1 text-xs font-semibold text-white shadow-md">
            {item.badge}
          </span>
        )}
      </div>

      {/* ================= CONTENT ================= */}
      <div className="flex flex-col p-4 sm:p-5">
        {/* Heading */}
        <h2 className="line-clamp-2 text-base font-bold leading-tight text-gray-900 sm:text-xl">
          {item?.heading}
        </h2>

        {/* Description */}
        {item?.paragraph && (
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-gray-600 sm:text-base">
            {item.paragraph}
          </p>
        )}

        {/* CTA */}
        <div className="mt-4 flex items-center justify-between gap-3">
          <span className="text-xs font-medium uppercase tracking-wide text-gray-400 sm:text-sm">
            Limited Deal
          </span>

          <button
            type="button"
            onClick={handleBookNow}
            className="rounded-full bg-red-500 px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-all duration-200 hover:bg-red-600 hover:shadow-lg active:scale-95 sm:px-6 sm:text-sm"
          >
            Book Now
          </button>
        </div>
      </div>
    </article>
  );
}